(function () {
	if (window.__sterilairCatalogProduct) return
	window.__sterilairCatalogProduct = true

	function stars(count) {
		var value = Math.max(0, Math.min(5, Math.round(Number(count) || 0)))
		return '★★★★★'.slice(0, value) + '☆☆☆☆☆'.slice(0, 5 - value)
	}

	// Ícones do Next (lucide) usados nas avaliações — mesmos paths, para o visual ficar idêntico.
	var STAR_PATH = 'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z'
	function svgIcon(body, size, extra) {
		return '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"' + (extra || '') + '>' + body + '</svg>'
	}
	var ICONS = {
		calendar: svgIcon('<path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/>', 14),
		badgeCheck: svgIcon('<path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/>', 18, ' class="catalog-review-icon--sky"'),
		ban: svgIcon('<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>', 18, ' class="catalog-review-icon--red"'),
		banLarge: svgIcon('<circle cx="12" cy="12" r="10"/><path d="m4.9 4.9 14.2 14.2"/>', 24, ' class="catalog-review-icon--red"'),
		circleCheck: svgIcon('<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>', 24, ' class="catalog-review-icon--green"'),
		chevronLeft: svgIcon('<path d="m15 18-6-6 6-6"/>', 24),
		chevronRight: svgIcon('<path d="m9 18 6-6-6-6"/>', 24),
		reply: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="catalog-review-reply__icon" aria-hidden="true"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"/></svg>'
	}
	// formatStars do Next: cheias, meia (gradiente) e vazias (só contorno), todas #ffc107.
	function starsSvg(rating, size) {
		var value = Math.max(0, Math.min(5, Number(rating) || 0))
		var full = Math.floor(value)
		var half = value % 1 >= 0.5 ? 1 : 0
		var out = ''
		for (var i = 0; i < 5; i += 1) {
			var fill = i < full ? '#ffc107' : (i === full && half ? 'url(#catalog-star-half)' : 'none')
			out += '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="' + fill + '" stroke="#ffc107" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>'
		}
		return out
	}
	if (!document.getElementById('catalog-star-half')) {
		var defs = document.createElement('div')
		defs.setAttribute('aria-hidden', 'true')
		defs.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden'
		defs.innerHTML = '<svg><defs><linearGradient id="catalog-star-half" x1="0" x2="1" y1="0" y2="0"><stop offset="50%" stop-color="#ffc107"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs></svg>'
		document.body.appendChild(defs)
	}

	function initGallery(root) {
		var track = root.querySelector('[data-catalog-track]')
		var slides = root.querySelectorAll('[data-catalog-slide]')
		var thumbs = root.querySelectorAll('[data-catalog-thumb]')
		if (!track || !slides.length) return
		var index = 0
		var startX
		function select(next) {
			index = (next + slides.length) % slides.length
			track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)'
			thumbs.forEach(function (thumb, thumbIndex) { thumb.classList.toggle('is-active', thumbIndex === index) })
		}
		root.querySelector('[data-catalog-prev]')?.addEventListener('click', function () { select(index - 1) })
		root.querySelector('[data-catalog-next]')?.addEventListener('click', function () { select(index + 1) })
		thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { select(Number(thumb.dataset.catalogThumb)) }) })
		root.querySelector('[data-catalog-viewport]')?.addEventListener('pointerdown', function (event) { startX = event.clientX })
		root.querySelector('[data-catalog-viewport]')?.addEventListener('pointerup', function (event) { if (startX === undefined) return; var distance = event.clientX - startX; startX = undefined; if (Math.abs(distance) >= 40) select(index + (distance < 0 ? 1 : -1)) })
	}

	// Mesmo mecanismo real da PDP do purificador (product-shipping-estimate.js,
	// carregado globalmente em theme.liquid) — antes disso, o botão só
	// mostrava uma mensagem genérica, sem consultar frete de verdade.
	function initShipping(root) {
		root.querySelectorAll('[data-catalog-postal]').forEach(function (input) {
			var wrap = input.closest('.catalog-offer__shipping')
			var button = wrap.querySelector('[data-catalog-shipping]')
			var message = wrap.querySelector('[data-catalog-shipping-message]')
			var results = wrap.querySelector('[data-catalog-shipping-results]')
			var variantInput = wrap.closest('.catalog-offer').querySelector('input[name="id"]')
			var promptLabel = button.dataset.promptLabel || button.textContent.trim()
			var readyLabel = button.dataset.readyLabel || promptLabel

			input.addEventListener('input', function () {
				var digits = input.value.replace(/\D/g, '').slice(0, 8)
				input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits
				var ready = digits.length === 8
				button.disabled = !ready
				button.textContent = ready ? readyLabel : promptLabel
				message.hidden = true
				results.hidden = true
			})

			button.addEventListener('click', function () {
				var estimator = window.SterilairShippingEstimate
				var variantId = variantInput && variantInput.value
				if (!estimator || !variantId) { message.hidden = false; return }

				message.hidden = true
				results.hidden = false
				results.textContent = 'Calculando…'
				button.disabled = true

				estimator.estimateShipping(variantId, input.value)
					.then(function (data) {
						var rates = data && data.shipping_rates
						if (!rates || !rates.length) {
							results.innerHTML = '<p class="catalog-shipping__error">Não encontramos opções de frete para esse CEP.</p>'
							return
						}
						results.innerHTML = rates.map(function (rate) {
							var estimate = formatDeliveryDate(rate.delivery_date)
							return '<div class="catalog-shipping__rate">' +
								'<div class="catalog-shipping__rate-info"><strong>' + escapeHtml(rate.name) + '</strong>' +
								(estimate ? '<span>Estimado: ' + estimate + '</span>' : '') + '</div>' +
								'<div class="catalog-shipping__rate-price">' + estimator.formatShippingPrice(rate.price) + '</div>' +
							'</div>'
						}).join('')
					})
					.catch(function () {
						results.hidden = true
						message.hidden = false
					})
					.finally(function () { button.disabled = false })
			})
		})
	}

	function initRating(root) {
		// A seção de avaliações (.catalog-reviews) é outra section, fora de
		// `root` — por isso a busca é a partir do documento, não de `root`.
		var widget = root.querySelector('[data-catalog-rating]')
		if (widget) {
			widget.addEventListener('click', function () {
				document.querySelector('.catalog-reviews')?.scrollIntoView({ behavior: 'smooth' })
			})
			widget.addEventListener('keydown', function (event) {
				if (event.key !== 'Enter' && event.key !== ' ') return
				event.preventDefault()
				document.querySelector('.catalog-reviews')?.scrollIntoView({ behavior: 'smooth' })
			})
		}

		var url = root.dataset.ratingUrl
		if (!url) return
		fetch(url).then(function (response) { if (!response.ok) throw new Error('Falha ao buscar avaliações'); return response.json() }).then(function (data) {
			var rating = Array.isArray(data) ? data[0] : null
			if (!rating || !widget) return
			// Igual ao Next: essa nota do topo arredonda pra estrela cheia, sem
			// meia estrela — a meia estrela do starsSvg() é só pra avaliação
			// individual (review.rating, que já é inteiro de 1 a 5).
			widget.querySelector('span:first-child').innerHTML = starsSvg(Math.round(rating.aggregateRating), 20)
			widget.querySelector('[data-catalog-rating-count]').textContent = Number(rating.reviewCount || 0).toLocaleString('pt-BR')
		}).catch(function () {})
	}

	document.querySelectorAll('[data-catalog-product]').forEach(function (root) {
		var gallery = root.querySelector('[data-catalog-gallery]')
		if (gallery) initGallery(gallery)
		initShipping(root)
		initRating(root)
	})

	function formatDate(value) {
		// formatStringToDate do Next: sempre em UTC (senão a data pode cair um dia antes no Brasil)
		var date = new Date(value)
		return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('pt-BR', { timeZone: 'UTC' })
	}

	function formatDeliveryDate(value) {
		var date = new Date(value)
		if (Number.isNaN(date.getTime())) return ''
		return date.toLocaleDateString('pt-BR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' })
	}

	function escapeHtml(value) {
		var node = document.createElement('div')
		node.textContent = value || ''
		return node.innerHTML
	}

	var PLAY_ICON = '<span class="catalog-review-media__play" aria-hidden="true">' +
		'<svg viewBox="0 0 68 48" width="48" height="48">' +
			'<path class="catalog-review-media__play-bg" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path>' +
			'<path d="M 45,24 27,14 27,34" fill="#fff"></path>' +
		'</svg>' +
	'</span>'

	function mediaItems(review) {
		// mesma ordem do Next (ReviewGalleryImage): fotos primeiro, vídeo por último
		var items = []
		;(review.pictures || []).forEach(function (picture) {
			if (picture && picture.url) items.push({ type: 'image', url: picture.url, thumb: picture.thumb || picture.url })
		})
		if (review.video && review.video.url) items.push({ type: 'video', url: review.video.url, thumb: review.video.thumb || '' })
		return items
	}

	function renderMedia(review, reviewIndex) {
		var items = mediaItems(review)
		if (!items.length) return ''
		return '<div class="catalog-review-media">' + items.map(function (item, index) {
			return '<button type="button" class="catalog-review-media__thumb' + (item.type === 'video' ? ' is-video' : '') + '"' +
				' data-review-index="' + reviewIndex + '" data-media-index="' + index + '" aria-label="Abrir mídia da avaliação">' +
				'<img src="' + escapeHtml(item.thumb) + '" loading="lazy" alt="">' +
				(item.type === 'video' ? PLAY_ICON : '') +
			'</button>'
		}).join('') + '</div>'
	}

	function renderReviews(root, reviews, options) {
		var store = !!(options && options.store)
		var list = root.querySelector('[data-review-list]')
		if (!reviews.length) {
			list.innerHTML = '<div class="catalog-review-card catalog-review-card--empty">Nenhuma avaliação encontrada para este filtro.</div>'
			return
		}
		root.__reviews = reviews
		list.innerHTML = reviews.map(function (review, index) {
			var text = review.text || ''
			// GetStoreReviews (Next): sem "Ler mais", sem mídia/resposta, selo de data sem ícone,
			// sempre "Compra Verificada" e "Sim, recomendaria".
			var clamp = !store && text.length > 500
			var textHtml = text
				? '<p class="catalog-review-card__paragraph' + (clamp ? ' is-clamped' : '') + '">' + escapeHtml(text) + '</p>' +
					(clamp ? '<button type="button" class="catalog-review-card__more" data-review-more>Ler mais...</button>' : '')
				: '<span class="catalog-review-card__empty">Cliente avaliou mas não quis deixar comentários.</span>'
			if (store) {
				return '<article class="catalog-review-card">' +
					'<div class="catalog-review-card__meta"><time class="catalog-review-card__date">' + formatDate(review.created) + '</time><div class="catalog-review-card__name">Cliente: ' + escapeHtml(review.name) + '</div></div>' +
					'<div class="catalog-review-card__proof"><div class="catalog-review-card__stars" aria-label="' + Number(review.rating || 0) + ' de 5 estrelas">' + starsSvg(review.rating, 16) + '</div>' +
						'<div class="catalog-review-card__verified">' + ICONS.badgeCheck + ' <span>Compra Verificada</span></div></div>' +
					'<div class="catalog-review-card__body">' +
						'<div class="catalog-review-card__recommended">' + ICONS.circleCheck + '<span>Sim, recomendaria este produto a um amigo</span></div>' +
						'<div class="catalog-review-card__text">' + textHtml + '</div>' +
					'</div>' +
				'</article>'
			}
			var reply = review.reply && review.reply.emailText
				? '<div class="catalog-review-reply">' +
						'<div class="catalog-review-reply__badge">' + ICONS.reply + '</div>' +
						'<div class="catalog-review-reply__content">' +
							'<div class="catalog-review-reply__head"><span class="catalog-review-reply__store">Sterilair</span><span class="catalog-review-card__date catalog-review-card__date--inline">' + ICONS.calendar + '<span>' + formatDate(review.reply.created || review.created) + '</span></span></div>' +
							'<div class="catalog-review-reply__text">' + escapeHtml(review.reply.emailText) + '</div>' +
						'</div>' +
					'</div>'
				: ''
			return '<article class="catalog-review-card">' +
				'<div class="catalog-review-card__meta"><time class="catalog-review-card__date">' + ICONS.calendar + ' ' + formatDate(review.created) + '</time><div class="catalog-review-card__name">Cliente: ' + escapeHtml(review.name) + '</div></div>' +
				'<div class="catalog-review-card__proof"><div class="catalog-review-card__stars" aria-label="' + Number(review.rating || 0) + ' de 5 estrelas">' + starsSvg(review.rating, 16) + '</div>' +
					'<div class="catalog-review-card__verified">' + (review.verified ? ICONS.badgeCheck + ' <span>Compra Verificada</span>' : ICONS.ban + ' <span>Compra não verificada</span>') + '</div></div>' +
				'<div class="catalog-review-card__body">' +
					'<div class="catalog-review-card__recommended">' + (review.recommended === false ? ICONS.banLarge + '<span>Não recomendaria este produto a um amigo</span>' : ICONS.circleCheck + '<span>Sim, recomendaria este produto a um amigo</span>') + '</div>' +
					'<div class="catalog-review-card__text">' + textHtml + '</div>' +
					renderMedia(review, index) +
				'</div>' +
				reply +
			'</article>'
		}).join('')
	}

	function openLightbox(root, review, startIndex) {
		var items = mediaItems(review)
		if (!items.length) return
		var index = startIndex || 0

		var box = document.createElement('div')
		box.className = 'catalog-lightbox'
		box.innerHTML =
			'<div class="catalog-lightbox__card" role="dialog" aria-modal="true" aria-label="Mídia da avaliação">' +
				'<div class="catalog-lightbox__stage" data-lb-stage></div>' +
				'<div class="catalog-lightbox__aside">' +
					'<div class="catalog-lightbox__head">' +
						'<div class="catalog-lightbox__stars">' + starsSvg(review.rating, 20) + '</div>' +
						'<button type="button" class="catalog-lightbox__close" data-lb-close aria-label="Fechar">' + svgIcon('<path d="M18 6 6 18"/><path d="m6 6 12 12"/>', 30) + '</button>' +
					'</div>' +
					'<div class="catalog-lightbox__thumbs" data-lb-thumbs></div>' +
					'<p class="catalog-lightbox__text">' + escapeHtml(review.text || '') + '</p>' +
					'<p class="catalog-lightbox__name">' + escapeHtml(review.name || '') + '</p>' +
					'<p class="catalog-lightbox__date">' + formatDate(review.created) + '</p>' +
				'</div>' +
			'</div>'
		document.body.appendChild(box)

		var stage = box.querySelector('[data-lb-stage]')
		var thumbs = box.querySelector('[data-lb-thumbs]')

		function paint() {
			var item = items[index]
			stage.innerHTML = item.type === 'video'
				? '<video src="' + escapeHtml(item.url) + '" controls preload="metadata"' + (item.thumb ? ' poster="' + escapeHtml(item.thumb) + '"' : '') + '></video>'
				: '<img src="' + escapeHtml(item.url) + '" alt="Foto enviada pelo cliente">'
			thumbs.innerHTML = items.map(function (thumbItem, thumbIndex) {
				return '<button type="button" class="catalog-lightbox__thumb' + (thumbIndex === index ? ' is-active' : '') + '" data-lb-go="' + thumbIndex + '">' +
					'<img src="' + escapeHtml(thumbItem.thumb || thumbItem.url) + '" alt="">' +
				'</button>'
			}).join('')
		}

		function close() {
			box.remove()
			document.removeEventListener('keydown', onKey)
		}
		function onKey(event) { if (event.key === 'Escape') close() }

		box.addEventListener('click', function (event) {
			var go = event.target.closest('[data-lb-go]')
			if (go) { index = Number(go.dataset.lbGo); paint(); return }
			if (event.target === box || event.target.closest('[data-lb-close]')) close()
		})
		document.addEventListener('keydown', onKey)
		paint()
	}

	function initReviews(root) {
		var base = (root.dataset.apiBase || 'https://reviews-api.konfidency.com.br/sterilair').replace(/\/$/, '')
		var sku = root.dataset.reviewSku
		var page = 1
		var pageSize = 10
		var totalPages = 1
		var filter = root.querySelector('[data-review-filter]')
		var sort = root.querySelector('[data-review-sort]')
		var pager = root.querySelector('[data-review-pager]')
		var previous = root.querySelector('[data-review-prev]')
		var next = root.querySelector('[data-review-next]')

		fetch(base + '/all-reviews?pageSize=1').then(function (response) { return response.json() }).then(function (data) {
			var summary = data?.reviews?.summary
			if (!summary) return
			var score = Number(summary.aggregateRating || 0)
			root.querySelector('[data-summary-rating]').textContent = score.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
			root.querySelector('[data-summary-stars]').textContent = stars(score)
			root.querySelector('[data-summary-count]').textContent = Number(summary.reviewCount || 0).toLocaleString('pt-BR')
			root.querySelector('[data-summary-recommended]').textContent = Math.round(Number(summary.recommendedPercentage || 0)) + '%'
			root.querySelectorAll('[data-summary-score]').forEach(function (node) { node.textContent = score.toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + '/5' })
			root.querySelectorAll('[data-summary-bar]').forEach(function (node) { node.style.width = Math.min(score / 5 * 100, 100) + '%' })
		}).catch(function () {})

		root.addEventListener('click', function (event) {
			var more = event.target.closest('[data-review-more]')
			if (more) {
				var paragraph = more.previousElementSibling
				var clamped = paragraph.classList.toggle('is-clamped')
				more.textContent = clamped ? 'Ler mais...' : 'Ler menos...'
				return
			}
			var thumb = event.target.closest('[data-review-index][data-media-index]')
			if (!thumb) return
			var review = (root.__reviews || [])[Number(thumb.dataset.reviewIndex)]
			if (review) openLightbox(root, review, Number(thumb.dataset.mediaIndex))
		})

		var isStoreScope = root.dataset.reviewScope === 'store'

		// Filtros de produto iguais aos do Next: hasText / filterMedia=any|pictures|videos|none
		var MEDIA_FILTERS = { 'media-any': 'any', media: 'any', pictures: 'pictures', videos: 'videos', none: 'none' }
		function countForFilter(summary, value) {
			var total = Number(summary?.reviewCount || 0)
			var media = Number(summary?.mediaReviews || 0)
			if (value === 'text') return Number(summary?.textReviews || 0)
			if (value === 'media-any' || value === 'media') return media
			if (value === 'pictures') return Number(summary?.pictureReviews || 0)
			if (value === 'videos') return Number(summary?.videoReviews || 0)
			if (value === 'none') return Math.max(total - media, 0)
			return total
		}
		function scrollToList(shouldScroll) {
			if (shouldScroll) root.scrollIntoView({ behavior: 'smooth' })
		}

		function setOptionCounts(countFn) {
			Array.prototype.forEach.call(filter.options, function (option) {
				if (!option.dataset.label) option.dataset.label = option.textContent
				option.textContent = option.dataset.label + ' (' + countFn(option.value) + ')'
			})
		}

		// Como no Next: <select> com todas as páginas + "Exibindo resultados: X a Y de N".
		function paintPager(count, shown) {
			totalPages = Math.max(1, Math.ceil(count / pageSize))
			var pageSelect = root.querySelector('[data-review-page]')
			var options = ''
			for (var i = 1; i <= totalPages; i += 1) options += '<option value="' + i + '"' + (i === page ? ' selected' : '') + '>' + i + '</option>'
			pageSelect.innerHTML = options
			pageSelect.disabled = totalPages <= 1
			var start = count ? (page - 1) * pageSize + 1 : 0
			var end = count ? Math.min(start + shown - 1, count) : 0
			var summaryNode = root.querySelector('[data-review-range]')
			if (summaryNode) summaryNode.innerHTML = 'Exibindo resultados: <strong>' + start + '</strong> a <strong>' + end + '</strong> de <strong>' + count.toLocaleString('pt-BR') + '</strong> avaliações'
			previous.disabled = page <= 1
			next.disabled = page >= totalPages
			pager.hidden = count === 0
		}

		// GetStoreReviews (Next): a lista completa de /store-reviews/published/<ordem>
		// tem mais de 11 mil itens e leva dezenas de segundos para baixar. Por isso
		// a primeira exibição (filtro "Todas") pede só a página atual ao servidor,
		// que aceita page/pageSize, e a lista completa baixa em segundo plano para
		// habilitar os filtros (comentário / estrelas) e as contagens no navegador.
		var storeCache = {}
		var storeAll = {}
		var storeToken = 0
		function filterStore(items, value) {
			var match = /^rating-(\d)$/.exec(value)
			if (value === 'with-text') return items.filter(function (item) { return item.text && item.text.trim() })
			if (value === 'without-text') return items.filter(function (item) { return !(item.text && item.text.trim()) })
			if (match) return items.filter(function (item) { return Number(item.rating) === Number(match[1]) })
			return items
		}
		function fetchStoreAll(key) {
			return storeCache[key] || (storeCache[key] = fetch(base + '/store-reviews/published/' + key)
				.then(function (response) { if (!response.ok) throw new Error(); return response.json() })
				.then(function (data) {
					storeAll[key] = data?.results || []
					return storeAll[key]
				})
				.catch(function (error) { delete storeCache[key]; throw error }))
		}
		function paintStore(all) {
			var filtered = filterStore(all, filter.value)
			var count = filtered.length
			var maxPage = Math.max(1, Math.ceil(count / pageSize))
			if (page > maxPage) page = maxPage
			var slice = filtered.slice((page - 1) * pageSize, page * pageSize)
			renderReviews(root, slice, { store: true })
			setOptionCounts(function (value) { return filterStore(all, value).length })
			paintPager(count, slice.length)
		}
		function readInitialStoreReviews() {
			var node = root.querySelector('[data-initial-reviews]')
			if (!node) return null
			try {
				var data = JSON.parse(node.textContent)
				return data && data.itens && data.itens.length ? { itens: data.itens, total: Number(data.total) || data.itens.length } : null
			} catch (error) { return null }
		}
		function loadStore(shouldScroll) {
			scrollToList(shouldScroll)
			var key = sort.value
			var token = ++storeToken
			var list = root.querySelector('[data-review-list]')
			var fail = function () { if (token === storeToken) list.innerHTML = '<p>Não foi possível carregar as avaliações.</p>' }

			if (storeAll[key]) { paintStore(storeAll[key]); return }

			// Lista completa ainda não chegou: baixa em segundo plano (uma vez por ordenação)
			function startFull() {
				fetchStoreAll(key).then(function (all) {
					// Chegou: repinta pela lista local (contagens e filtros) se a ordenação ainda é a mesma
					if (sort.value === key) { root.__storeReady = true; paintStore(all) }
				}).catch(fail)
			}

			if (filter.value !== 'all') { list.innerHTML = '<p>Carregando avaliações...</p>'; startFull(); return }

			// Primeira exibição: as 10 mais recentes já vêm na página (metacampo diário),
			// então a lista aparece na hora e a API só confirma e atualiza depois.
			if (!root.__storeReady && page === 1 && sort.value === 'created,-1') {
				var initial = readInitialStoreReviews()
				if (initial) {
					root.__storeReady = true
					renderReviews(root, initial.itens, { store: true })
					paintPager(initial.total, initial.itens.length)
				}
			}

			// Filtro "Todas": página atual direto do servidor. O download completo só
			// começa depois, para não disputar o servidor com a primeira exibição.
			if (!root.__storeReady) list.innerHTML = '<p>Carregando avaliações...</p>'
			var query = new URLSearchParams({ page: String(page), pageSize: String(pageSize) })
			fetch(base + '/store-reviews/published/' + key + '?' + query.toString())
				.then(function (response) { if (!response.ok) throw new Error(); return response.json() })
				.then(function (data) {
					if (token === storeToken && !storeAll[key]) {
						var results = data?.results || []
						var total = Number(data?.total || results.length)
						root.__storeReady = true
						renderReviews(root, results, { store: true })
						paintPager(total, results.length)
					}
					startFull()
				})
				.catch(function () { startFull() })
		}

		function loadProduct(shouldScroll) {
			var query = new URLSearchParams({ page: String(page), pageSize: String(pageSize) })
			if (filter.value === 'text') query.set('hasText', 'true')
			if (MEDIA_FILTERS[filter.value]) query.set('filterMedia', MEDIA_FILTERS[filter.value])
			scrollToList(shouldScroll)
			root.querySelector('[data-review-list]').innerHTML = '<p>Carregando avaliações...</p>'
			var url = base + '/' + encodeURIComponent(sku) + '/summary/' + sort.value + '?' + query.toString()
			fetch(url).then(function (response) { if (!response.ok) throw new Error(); return response.json() }).then(function (data) {
				var summary = data?.reviews?.[0]
				var listData = summary?.reviews || []
				var count = countForFilter(summary, filter.value)
				renderReviews(root, listData)
				// contagem por filtro no próprio <option>, como "Todas (15909)" no Next
				setOptionCounts(function (value) { return countForFilter(summary, value) })
				paintPager(count, listData.length)
			}).catch(function () { root.querySelector('[data-review-list]').innerHTML = '<p>Não foi possível carregar as avaliações.</p>' })
		}

		function load(shouldScroll) { return isStoreScope ? loadStore(shouldScroll) : loadProduct(shouldScroll) }
		filter.addEventListener('change', function () { page = 1; load(true) })
		sort.addEventListener('change', function () { page = 1; load(true) })
		previous.addEventListener('click', function () { if (page > 1) { page -= 1; load(true) } })
		next.addEventListener('click', function () { if (page < totalPages) { page += 1; load(true) } })
		root.querySelector('[data-review-page]').addEventListener('change', function (event) {
			var target = Number(event.target.value)
			if (target >= 1 && target <= totalPages && target !== page) { page = target; load(true) }
		})
		previous.innerHTML = ICONS.chevronLeft + '<span>Anterior</span>'
		next.innerHTML = '<span>Próxima</span>' + ICONS.chevronRight
		load(false)
	}

	document.querySelectorAll('[data-catalog-reviews]').forEach(function (el) {
		if (el.dataset.catalogReviewsReady === 'true') return
		el.dataset.catalogReviewsReady = 'true'
		initReviews(el)
	})
})()
